const Shop = () => {
	window.location.href = "https://shop.pcbang.ma"
	return null
}

export default Shop;